import {SET_CURRENT_USER_PRESENCE} from '../action_types'

import {PRESENCE} from '../../config/constants'

export default (state = PRESENCE.ONLINE, action) => {
  switch(action.type) {
    case SET_CURRENT_USER_PRESENCE:
      return action.presence
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/current_user_presence.js
 **/